import '@mdi/font/css/materialdesignicons.min.css'
import Vue from 'vue';
import Vuetify, {VApp,
    VToolbar,
    VCard,
    VBtn,
    VList,
    VListGroup,
    VAvatar,
    VIcon, VTextField, VSpacer, VDivider, VAlert, VChip, VTextarea, VSelect} from 'vuetify/lib';

Vue.use(Vuetify, {
        VApp,
        VToolbar,
        VCard,
        VBtn,
        VList,
        VListGroup,
        VAvatar,
        VIcon,
        VTextField,
        VSpacer,
        VDivider,
        VAlert,
        VChip,
        VTextarea,
    VSelect
});

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
});
